// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutHeader_container__1WZLl","sokiLogo":"AboutHeader_sokiLogo__9IQKJ"};